import { type PickerProps } from 'antd/es/date-picker/generatePicker';
import styled from 'styled-components';
import { type DatePickerValue } from '../../../calculator/fieldComponents';
import DayjsDatePicker from '../../../components/fields/DayjsDatePicker';
import CalendarIcon from '../../../icons/mobility/calendar.svg';

const DatePickerContainer = styled.div`
    width: 100%;
`;

const StyledDayjsDatePicker = styled(DayjsDatePicker)`
    width: 100%;
    font-size: 1rem;
    height: 54px;
    border: 2px solid rgb(107, 109, 112);
    box-shadow: none;
    border-radius: 4px;
    outline: 0px;
    line-height: 36px;
    padding: 8px 16px;

    &:focus:not(:disabled) {
        border-color: rgb(1, 2, 5);
    }

    &.ant-picker:hover,
    &.ant-picker-focused {
        border-right-width: 2px;
        border-color: rgb(1, 2, 5);
        box-shadow: none;
    }

    &.ant-picker .ant-picker-input {
        width: 100%;
        input {
            font-size: 1rem;
        }
    }

    /* Correspond src/app/calculator/GridCalculator/fields/shared/FormItem.tsx &.form-item-error */
    /* That should be borderless. And this one override the border color */
    .ant-form-item-has-error & {
        border-color: rgb(224, 0, 0);

        &.ant-picker:hover,
        &.ant-picker-focused {
            border-right-width: 2px;
            border-color: rgb(1, 2, 5);
            box-shadow: none;

            input::placeholder {
                color: rgb(1, 2, 5);
            }
        }
    }
`;

const DatePickerField = (props: PickerProps<DatePickerValue>) => (
    <DatePickerContainer className="porsche-v3-calculator-date-picker-field-wrapper">
        <StyledDayjsDatePicker {...props} suffixIcon={<CalendarIcon />} />
    </DatePickerContainer>
);
export default DatePickerField;
